import Big from "big.js";
import { orderBy } from "lodash";
const DECIMALS = 6;
const STEP = Big(`1e-${DECIMALS}`);
export const normalizeAllocations = (rows)=>{
    if (!rows?.length) return rows;
    const exactTotal = rows.reduce((acc, row)=>acc.plus(row.percentAllocation), Big(0));
    const rounded = rows.map((row)=>Big(row.percentAllocation).round(DECIMALS, Big.roundHalfUp));
    const residue = Big(1).minus(rounded.reduce((acc, value)=>acc.plus(value), Big(0)));
    /* absorb quantization residue only, so a genuinely wrong set keeps failing the authorize check */ if (residue.eq(0) || exactTotal.minus(1).abs().gt(STEP.times(rows.length))) {
        return rows.map((row, index)=>({
                ...row,
                percentAllocation: rounded[index].toNumber()
            }));
    }
    const bumped = new Set(orderBy(rows.map((row, index)=>({
            index,
            remainder: Big(row.percentAllocation).minus(rounded[index]).toNumber()
        })), 'remainder', residue.gt(0) ? 'desc' : 'asc').slice(0, residue.abs().div(STEP).round(0, Big.roundHalfUp).toNumber()).map((item)=>item.index));
    return rows.map((row, index)=>({
            ...row,
            percentAllocation: bumped.has(index) ? rounded[index].plus(residue.gt(0) ? STEP : STEP.times(-1)).toNumber() : rounded[index].toNumber()
        }));
};

//# sourceMappingURL=normalizeAllocations.js.map